import styled from "styled-components";
import { Text as BBText } from "@acko-tech/building-blocks.ui.typography";

export const ContentWrapper = styled.div<{ isDesktop?: boolean }>`
  padding: ${(p) => (p.isDesktop ? "24px" : "16px 20px 24px 20px")};
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
`;

export const TopImageWrapper = styled.div`
  width: 100%;
  margin-top: -26px;
  margin-bottom: 0;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
  }
`;

export const Title = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
  color: var(--Text-Primary-grey600, #121212);
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  align-self: stretch;
  margin-bottom: 12px;
`;

export const Text = styled(BBText)`
  font-size: 14px;
  line-height: 20px;
  color: #36354c;
`;

export const CardRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  margin-top: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-snap-stop: always;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  overscroll-behavior-x: contain;
  cursor: grab;
  scrollbar-width: none;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const Card = styled.div`
  flex: 0 0 300px;
  flex-shrink: 0;
  width: 300px;
  box-sizing: border-box;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  border: 1px solid #e7e7f0;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
  background: #ffffff;
  user-select: none;
`;

export const CardText = styled.div`
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-weight: 500;
  color: #121212;
`;

export const OrderLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`;

export const OrderLink = styled.a`
  display: block;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #1b73e8;
  text-decoration: none;
`;

export const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 12px 0;
`;

export const Dot = styled.div<{ active?: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => (p.active ? "#121212" : "#d9d9e3")};
  cursor: pointer;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  border-radius: 12px;
  border: none;
  background: #121212;
  color: #ffffff;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const FeatureItem = styled.div`
  display: block;
  margin-bottom: 12px;
  flex: 1 0 0;
`;

export const FeatureTitle = styled.span`
  color: #000;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`;

export const FeatureDescription = styled.span`
  color: #000;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const FeatureList = styled.div`
  margin-bottom: 24px;
`;
